import React from 'react';

import { QrIcon } from 'assets/icons';
import globalStyles from 'assets/stylesheets/global-styles.module.scss';
import { Button } from 'common/button';
import { RouteName, goToPage } from 'routes';

import { classnames } from 'helpers/utils';
import styles from './unlinked-qr-code.module.scss';

const UnlinkedQrCode: React.FC = () => (
  <div
    className={classnames(
      globalStyles.loggedMainContainer,
      styles.fullPageContent,
    )}
  >
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <div className={styles.icon}>
          <QrIcon />
        </div>
        <div className={classnames('text__heading4__gray800', styles.title)}>
          This QR code is not linked to a vault.
        </div>
      </div>
      <p className="text__body__regular__medium__gray700">
        If you&apos;re the owner, scan it with the Generational Story app to
        connect it to a vault or clip.
      </p>
      <Button
        className={styles.button}
        onClick={() => goToPage(RouteName.Home)}
      >
        Go back home
      </Button>
    </div>
  </div>
);

export { UnlinkedQrCode };
